var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Custom-Select',{attrs:{"label":_vm.label,"items":_vm.dictionariesGetter,"multiple":_vm.multiple},model:{value:(_vm.list),callback:function ($$v) {_vm.list=$$v},expression:"list"}})}
var staticRenderFns = []

export { render, staticRenderFns }